<template>
  <div ref="root" class="mx-auto max-w-2xl px-4 text-center">
    <p data-reveal class="font-mono text-sm text-[var(--accent)]">{{ t('contact.title') }}</p>
    <h2 data-reveal class="mt-1 text-3xl font-bold">{{ t('contact.heading') }}</h2>
    <p data-reveal class="mt-3 text-[var(--muted)]">{{ t('contact.text') }}</p>
    <p data-reveal class="mt-4 font-mono text-xs text-[var(--muted)]">
      {{ t('contact.location') }} · {{ t('contact.phone') }}
    </p>
    <div data-reveal class="mt-6 flex flex-wrap justify-center gap-3">
      <a
        href="https://github.com/lnxdxtf"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 rounded-md bg-[var(--accent)] px-4 py-2 font-mono text-sm text-[var(--bg)] transition-opacity hover:opacity-90"
      >
        <Icon icon="mdi:github" /> {{ t('contact.github') }}
      </a>
      <a
        href="https://www.linkedin.com/in/gabrielrmichaliszen"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 rounded-md border border-[var(--border)] px-4 py-2 font-mono text-sm transition-colors hover:border-[var(--accent)] hover:text-[var(--accent)]"
      >
        <Icon icon="mdi:linkedin" /> {{ t('contact.linkedin') }}
      </a>
      <a
        :href="`mailto:${t('contact.email')}`"
        class="inline-flex items-center gap-2 rounded-md border border-[var(--border)] px-4 py-2 font-mono text-sm transition-colors hover:border-[var(--accent)] hover:text-[var(--accent)]"
      >
        <Icon icon="mdi:email-outline" /> {{ t('contact.email') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'
import { useReveal } from '../composables/useMotion'

const { t } = useI18n()
const root = ref<HTMLElement | null>(null)
useReveal(root)
</script>
